export const SAVE_ROOMS = "save_rooms"
export const UPDATE_SELF_USERID = "update_self_userid"
export const CURRENT_STATUS = "current_status"
export const UPDATE_WS = "upadte_ws"
export const UPDATE_MESSAGE = "update_message"
export const ONLINE_STATUS = "online_status"
export const UPDATE_MESSAGE_STATUS = "update_message_status"
export const UPDATE_AUTHENTICATED = "update_autheticated"
export const LOGIN_USER = "login_user"
export const LOGOUT_USER = "logout_user"
export const CHECK_LOGIN_USER = "check_login_user"
export const SWITCH_LOAD = "switch_load"
export const CONNECT_WEBSOCKET = "connect_websocket"


// UI ACTIONS

export const SWITCH_SIDEBAR = "switch_sidebar"
export const SWITCH_DARK_MODE = "switch_dark_mode"

